// Blog posts data.
// Each post: num (id), slug (url), title, description (short excerpt for
// list views), date ('DD Mon YYYY'), tags (indices into TagList), views,
// and content (markdown body rendered on the post's own page).

const posts = [
  {
    num: 1,
    slug: 'the-first-post',
    title: "Two years later, the first post",
    description: "It's been 2 (or even more) years since I came up with this idea and built this project. Here's finally the first entry — and a plan to make it consistent.",
    date: '28 Jul 2026',
    tags: [4],
    views: 0,
    content: `It's been 2 (or even more) years since I've come up with this idea and created the structure, design, and code of this project. Yet here I am creating the first entry here only now.

I've planned so many times to begin this thing, but I always felt like the first post here is so special... And what is actually going to be special is to make it consistent. So let's see how I'm gonna do.`
  },
  {
    num: 2,
    slug: 'a-matter-of-perspective',
    title: "A matter of perspective",
    description: "One day you're on top of the world, the next everything's falling apart — and nothing actually changed. A short reflection on how subjective our sense of \"truth\" really is.",
    date: '29 Jul 2026',
    tags: [4, 5],
    views: 0,
    content: `That's quite insane how one day you are feeling on top of the world, and the very next day everything seems to be falling apart. At the same time nothing really changes, it's just the perspective.

It makes me wonder, how subjective the world we see is. Every single piece of news, every event goes through the lens of one's own experience, mistakes, disappointments, refracting and curving. We listen to others' opinions usually taking it as an ultimate truth, although it rarely is anything close to the truth, but rather one's own version of it.

And the worst part is that sometimes "other" is you yourself, but in a different mood.`
  }
];

export default posts;
